import { useMemo } from "react"

import { useParams } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { RoadDetailInfo } from "@l2r-front/l2r-networks"
import { Typography, useIsMobileDevice } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useEquipment } from "../../hooks/queries/equipment/useEquipments"

import { EquipmentDetails } from "../EquipmentDetails/EquipmentDetails"
import { EquipmentDocumentList } from "../EquipmentDocumentList"

import * as Styled from "./EquipmentDetailsSidebarContent.styled"

export function EquipmentDetailsSidebarContent() {

    const { signId: equipmentId, road } = useParams()
    const { data, isLoading, isError } = useEquipment(equipmentId)
    const isMobile = useIsMobileDevice()

    const { t } = useTranslation(I18N_NAMESPACE)
    const latLong = data?.geometry.coordinates

    const LatLongComponent = useMemo(() => {
        if (latLong) {
            return <Typography id="road-detail-latlong" variant="Regular">
                {latLong[1].toFixed(5)}, {latLong[0].toFixed(5)}
            </Typography>
        }
        return <Styled.Skeleton />
    }, [latLong])

    if (isLoading || !data) {
        return null
    }

    return <Styled.Container isMobile={isMobile}>
        <Styled.RoadDetailWrapper isMobile={isMobile}>
            <Styled.LocationHeader>
                <Typography variant="H3">
                    {t(I18N_NAMESPACE, "containers.equipmentDetailSidebar.location.title")}
                </Typography>
            </Styled.LocationHeader>
            <RoadDetailInfo
                LengthComponent={LatLongComponent}
                lengthLabel={`${t(I18N_NAMESPACE, "containers.equipmentDetailSidebar.location.latlong")} `}
                road={road}
            />
        </Styled.RoadDetailWrapper>
        <Styled.Wrapper isMobile={isMobile}>
            {
                isError ? <Styled.ErrorText>
                    {t(I18N_NAMESPACE, "containers.horizontalSignDetailSidebar.content.error")}
                </Styled.ErrorText>
                    : <EquipmentDetails equipment={data} />
            }
        </Styled.Wrapper>
        <EquipmentDocumentList equipmentId={equipmentId} />
    </Styled.Container>
}